function Login() {
    return <div className="container">
  <div className="row justify-content-center p-5">
  <div className="card" style={{width:"400px"}}>
      <div className="card-body">
      <div className="mb-3">
    <label className="form-label">Email address</label>
    <input type="email" className="form-control" id="email" aria-describedby="emailHelp" />
  </div>
  <div className="mb-3">
    <label className="form-label">Password</label>
    <input type="password" className="form-control" id="password" />
  </div>
  <div className="mb-3 form-check">
    <input type="checkbox" className="form-check-input" id="exampleCheck1" />
    <label className="form-check-label" htmlFor="exampleCheck1">Check me out</label>
  </div>
  <button type="submit" className="btn btn-primary">Login</button>
      </div>
  </div>

  </div>
</div>



}

export default Login;